module.exports = __webpack_public_path__ + "static/3.1_ancient_mesopotamia-3824f4bedab5109bb1e4a3ff64338c72.pdf";